import React from 'react';

export const DeleteProgramActivityFeedItemDescription = props => <p>
    {props.Event.Activity.User.name} removed the {props.CustomEventData ? props.CustomEventData.title : ""} Program.
</p>;



